export default "__VITE_ASSET__013149fe__"